import axios from "axios";
import { BASEURL } from "@/api/baseurl";
import router from "@/router";

axios.interceptors.response.use(
  (response) => {
    // If any API returns SESSION_TERMINATED, force logout
    if (
      response.data &&
      response.data.status === "0" &&
      response.data.code === "SESSION_TERMINATED"
    ) {
      forceLogout();
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

function forceLogout() {
  localStorage.removeItem("userInfo");
  localStorage.removeItem("session_token");
  sessionStorage.removeItem("session_token");
  router.push("/app/sessions/login?reason=session_terminated");
}